import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetch = () =>
    RESTClient.getAuthenticatedObservable('v2/conversation/preferences', {
        v2: 1,
    });

export const update = hideAsParticipantConst =>
    RESTClient.postAuthenticatedObservable('v2/conversation/preferences', {
        hideAsParticipantConst,
    });
